import React from 'react';

const BlogAuthor = ({ author }) => {
  if (!author?.name) return null;

  return (
    <div
      style={{
        display: 'flex',
        gap: '18px',
        alignItems: 'flex-start',
        padding: '24px',
        background: '#fff',
        borderRadius: '12px',
        border: '1px solid #EAEFEF',
        margin: '32px 0',
      }}
    >
      <div
        style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          backgroundColor: '#FF9B51',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 700,
          fontSize: '22px',
          flexShrink: 0,
        }}
      >
        {author.name.charAt(0).toUpperCase()}
      </div>
      <div>
        <p style={{ margin: '0 0 2px', fontSize: '13px', color: '#64748b', fontWeight: 500 }}>
          Written by
        </p>
        <h4 style={{ margin: '0 0 4px', fontSize: '16px', fontWeight: 700, color: '#25343F' }}>
          {author.name}
        </h4>
        {author.role && (
          <p style={{ margin: '0 0 8px', fontSize: '12px', color: '#FF9B51', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            {author.role}
          </p>
        )}
        {author.bio && (
          <p style={{ margin: 0, fontSize: '14px', color: '#64748b', lineHeight: 1.6 }}>
            {author.bio}
          </p>
        )}
      </div>
    </div>
  );
};

export default BlogAuthor;
